// src/components/RPA/buttons/ConductFinancialAuditButton.js
import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API || 'http://localhost:8000';

export default function ConductFinancialAuditButton({ docId, onDone }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!docId) return;
    
    setLoading(true);
    try {
      // FIXED: Use the correct route with docId in URL
      const res = await axios.post(
        `${API_URL}/admin/rpa/docs/${docId}/conduct/financial-audit`,
        {}, // Empty body since docId is in URL
        { withCredentials: true }
      );
      
      console.log('[CONDUCT_FS_AUDIT_BTN] Success:', res.data);
      if (onDone) onDone();
    } catch (err) {
      console.error('[CONDUCT_FS_AUDIT_BTN] Failed:', err);
      alert(err.response?.data?.message || 'Financial audit testing failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={loading}
      style={{
        background: loading ? '#9ca3af' : '#f97316',
        color: 'white',
        border: 'none',
        padding: '4px 8px',
        borderRadius: 4,
        fontSize: 11,
        cursor: loading ? 'not-allowed' : 'pointer',
        fontWeight: 500
      }}
    >
      {loading ? 'Testing…' : 'Conduct Audit'}
    </button>
  );
}